import React, { useCallback } from 'react';
import * as RadixCollapsible from '@radix-ui/react-collapsible';

const ExtendedContent = ({ children, ...props }) => {
  // Set overflow visible for sections that are open on mount (no animation runs)
  const ref = useCallback(node => {
    if (node && node.dataset.state === 'open') {
      node.style.overflow = 'visible';
    }
  }, []);

  const handleAnimationEnd = event => {
    if (event.animationName === 'slideDown' && event.target.dataset.state === 'open') {
      event.currentTarget.style.overflow = 'visible';
    }
  };

  const handleAnimationStart = event => {
    if (event.animationName === 'slideUp' && event.target.dataset.state === 'closed') {
      event.currentTarget.style.overflow = 'hidden';
    }
  };

  return (
    <RadixCollapsible.Content
      {...props}
      ref={ref}
      onAnimationEnd={handleAnimationEnd}
      onAnimationStart={handleAnimationStart}
    >
      {children}
    </RadixCollapsible.Content>
  );
};

const Collapsible = {
  Root: RadixCollapsible.Root,
  Trigger: RadixCollapsible.Trigger,
  Content: ExtendedContent,
};

export default Collapsible;
